module.exports = "/images/reportes.svg";